// Relative path: src/pages/Onboarding/slides/CoverSlide.js
/* eslint-disable */
import React, { useEffect, useState } from "react";
import SlideShell from "../SlideShell";
import IphoneVideo, { DEFAULT_IPHONE_VIDEO_PATH, DEFAULT_IPHONE_POSTER_PATH, isIphoneVideoReady } from "../../../components/IphoneVideo";
import PrimaryButton from "../../../components/Onboarding/PrimaryButton";

const THEMES = {
  light: {
    background: "bg-white",
    text: "text-zinc-900",
    subtitle: "text-zinc-600",
  },
  dark: {
    background: "bg-mm_black",
    text: "text-white",
    subtitle: "text-white/70",
  },
};

export default function CoverSlide({
  // Content
  title = "Hair restoration without fear",
  subtitle = "",
  description, // unused on cover
  imageSrc,    // unused (we show IphoneVideo instead)
  imageAlt = "",

  // NEW: footer subtext passthrough
  showFooterSubtext = false,
  footerSubtextText = '',
  footerSubtextProps = {},

  // Shell/flow
  theme = "light",
  currentStep,
  totalSteps,
  showProgress = false, // hidden by default on cover
  onNext,
  onBack,
  nextLabel = "Get your confidence back ->",

  // Animations & state
  disabled = false,
  animationDirection = "forward",
  isTransitioning = false,

  // Optional auto-advance
  autoAdvanceDelay = null, // e.g., 3000
}) {
  const currentTheme = THEMES[theme] || THEMES.light;
  const [isVideoReady, setIsVideoReady] = useState(() => isIphoneVideoReady(DEFAULT_IPHONE_VIDEO_PATH));

  useEffect(() => {
    if (!autoAdvanceDelay || !onNext) return;
    const timer = setTimeout(() => onNext?.(), autoAdvanceDelay);
    return () => clearTimeout(timer);
  }, [autoAdvanceDelay, onNext]);

  return (
    <div className={`min-h-screen ${currentTheme.background}`}>
      <div className={currentTheme.background}>
        <SlideShell
          title={null}
          subtitle={null}
          showBack={false}
          showLogo={false}
          currentStep={showProgress ? currentStep : undefined}
          totalSteps={showProgress ? totalSteps : undefined}
          showPrimary={false}
          footer={null}
          onNext={onNext}
          onBack={onBack}
          nextLabel={nextLabel}
          disabled={disabled}
          theme={theme}
          animationDirection={animationDirection}
          isTransitioning={isTransitioning}
          scrollable={false}

          /* These go here (usage site), NOT inside SlideShell.js */
          showFooterSubtext={true}
          footerSubtextText={footerSubtextText || 'By continuing, you agree to our '}
          footerSubtextProps={footerSubtextProps}
          privacyUrl="https://matchmedic.com/documents/PrivacyNotice"
          termsUrl="https://matchmedic.com/documents/TermsConditions"
          footerMode="legal"
        >
          {/* Responsive hero: stacked on mobile, two columns on lg+ */}
          <div className="w-full h-full max-w-6xl mx-auto px-4 py-5 lg:py-14">
            <div className="h-full flex flex-col items-center gap-4 lg:grid lg:grid-cols-12 lg:items-center lg:gap-12">
              {/* LEFT: iPhone frame - strictly contained & centered */}
              <div className="h-full lg:col-span-6 flex justify-center lg:justify-start min-w-0">
                <div
                  className="
                    relative rounded-xl mx-auto overflow-hidden
                    aspect-[1294/2656]
                    w-auto
                    h-full
                    min-h-[200px] md:min-h-[300px]
                  "
                >
                  <IphoneVideo
                    className="block h-full md:h-auto w-auto mx-auto"
                    videoPath={DEFAULT_IPHONE_VIDEO_PATH}
                    posterPath={DEFAULT_IPHONE_POSTER_PATH}
                    autoplayDelayMs={700}
                    onMediaLoaded={() => setIsVideoReady(true)}
                    onMediaError={() => setIsVideoReady(true)}
                  />
                </div>
              </div>

              {/* RIGHT: Title + CTA */}
              <div className="w-full lg:col-span-6 text-center lg:text-left">
                {title && (
                  <h1
                    className={[
                      "font-extrabold leading-tight",
                      "text-3xl md:text-4xl lg:text-5xl",
                      currentTheme.text,
                    ].join(" ")}
                  >
                    {title}
                  </h1>
                )}
                {subtitle && (
                  <p
                    className={[
                      "mt-2 leading-relaxed leading-snug",
                      "text-base md:text-lg",
                      currentTheme.subtitle,
                    ].join(" ")}
                  >
                    {subtitle}
                  </p>
                )}
                <div className="mt-6 flex justify-center lg:justify-start">
                  <PrimaryButton onClick={onNext} disabled={disabled}>
                    {nextLabel}
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </SlideShell>
      </div>
    </div>
  );
}

